var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeSkincareMinis2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#ECFF92"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FREE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5185 61.992V68.008H42.0705V71.4H34.5185V81H31.0945V58.6H44.3105V61.992H34.5185ZM56.7793 71.368H53.2913V81H49.8673V58.6H58.6673C63.1153 58.6 65.5473 61.128 65.5473 65C65.5473 68.296 63.7873 70.6 60.5233 71.208L66.2833 81H62.4433L56.7793 71.368ZM62.0593 65.032C62.0593 63.08 60.7473 61.992 58.6673 61.992H53.2913V68.072H58.6673C60.7473 68.072 62.0593 66.984 62.0593 65.032ZM74.88 61.992V68.008H82.432V71.4H74.88V77.608H84.672V81H71.456V58.6H84.672V61.992H74.88ZM95.3488 61.992V68.008H102.901V71.4H95.3488V77.608H105.141V81H91.9248V58.6H105.141V61.992H95.3488Z",
    fill: "black"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeSkincareMinis2);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM2IiBoZWlnaHQ9IjEzNiIgdmlld0JveD0iMCAwIDEzNiAxMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjY4IiBjeT0iNjgiIHI9IjY4IiBmaWxsPSIjRUNGRjkyIi8+CjxnIGlkPSJGUkVFIj4KPHBhdGggZD0iTTM0LjUxODUgNjEuOTkyVjY4LjAwOEg0Mi4wNzA1VjcxLjRIMzQuNTE4NVY4MUgzMS4wOTQ1VjU4LjZINDQuMzEwNVY2MS45OTJIMzQuNTE4NVpNNTYuNzc5MyA3MS4zNjhINTMuMjkxM1Y4MUg0OS44NjczVjU4LjZINTguNjY3M0M2My4xMTUzIDU4LjYgNjUuNTQ3MyA2MS4xMjggNjUuNTQ3MyA2NUM2NS41NDczIDY4LjI5NiA2My43ODczIDcwLjYgNjAuNTIzMyA3MS4yMDhMNjYuMjgzMyA4MUg2Mi40NDMzTDU2Ljc3OTMgNzEuMzY4Wk02Mi4wNTkzIDY1LjAzMkM2Mi4wNTkzIDYzLjA4IDYwLjc0NzMgNjEuOTkyIDU4LjY2NzMgNjEuOTkySDUzLjI5MTNWNjguMDcySDU4LjY2NzNDNjAuNzQ3MyA2OC4wNzIgNjIuMDU5MyA2Ni45ODQgNjIuMDU5MyA2NS4wMzJaTTc0Ljg4IDYxLjk5MlY2OC4wMDhIODIuNDMyVjcxLjRINzQuODhWNzcuNjA4SDg0LjY3MlY4MUg3MS40NTZWNTguNkg4NC42NzJWNjEuOTkySDc0Ljg4Wk05NS4zNDg4IDYxLjk5MlY2OC4wMDhIMTAyLjkwMVY3MS40SDk1LjM0ODhWNzcuNjA4SDEwNS4xNDFWODFIOTEuOTI0OFY1OC42SDEwNS4xNDFWNjEuOTkySDk1LjM0ODhaIiBmaWxsPSJibGFjayIvPgo8L2c+Cjwvc3ZnPgo=";